import React, { useState, useRef } from "react";
import { cn } from "~/lib/utils";
import * as SliderPrimitive from "@radix-ui/react-slider";
import * as Tooltip from "@radix-ui/react-tooltip";

export function SliderDemo({
  className,
  value = [50],
  showTooltip = true,
  tooltipSuffix = "",
  ...props
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // Track if we're dragging, or hovered, or focused
  const isDragging = useRef(false);

  // Thumb event handlers
  const handleThumbPointerDown = () => {
    isDragging.current = true;
    setTooltipOpen(true);
    // When the user starts dragging (mouse down on thumb)
    window.addEventListener('pointerup', handlePointerUp);
  };

  const handleThumbPointerEnter = () => {
    if (!isDragging.current) setTooltipOpen(true);
  };

  const handleThumbPointerLeave = () => {
    if (!isDragging.current) setTooltipOpen(false);
  };

  const handleThumbFocus = () => setTooltipOpen(true);
  const handleThumbBlur = () => {
    // Only close if not dragging (i.e. focus moves)
    if (!isDragging.current) setTooltipOpen(false);
  };

  // End drag on pointer up anywhere
  const handlePointerUp = () => {
    isDragging.current = false;
    setTooltipOpen(false);
    window.removeEventListener('pointerup', handlePointerUp);
  };

  return (
    <SliderPrimitive.Root
      value={value}
      className={cn("w-[100%] relative flex w-full touch-none select-none items-center", className)}
      {...props}
    >
      <SliderPrimitive.Track className='relative h-2 w-full grow overflow-hidden rounded-full bg-gray-400'>
        <SliderPrimitive.Range className='absolute h-full bg-oh-black' />
      </SliderPrimitive.Track>
      <Tooltip.Provider delayDuration={0}>
        <Tooltip.Root open={showTooltip ? tooltipOpen : false}>
          <Tooltip.Trigger asChild>
            <SliderPrimitive.Thumb
              className='block h-5 w-5 rounded-full border-2 border-oh-black bg-white ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50'
              onPointerDown={handleThumbPointerDown}
              onPointerEnter={handleThumbPointerEnter}
              onPointerLeave={handleThumbPointerLeave}
              onFocus={handleThumbFocus}
              onBlur={handleThumbBlur}
              aria-label="Value"
            />
          </Tooltip.Trigger>
          <Tooltip.Content
            side='top'
            align='center'
            className="select-none px-4 py-2 rounded bg-black text-white text-xs"
            sideOffset={2}
          >
            {value[0]}{tooltipSuffix}
            <Tooltip.Arrow className="fill-current text-black" />
          </Tooltip.Content>
        </Tooltip.Root>
      </Tooltip.Provider>
    </SliderPrimitive.Root>
  );
}